module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/PostingIcon.f53a045c.svg";